/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Nav_Developers_DescInputs */

const en_mk_nav_developers_desc = /** @type {(inputs: Mk_Nav_Developers_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Work with your agent, CLI, and MCP.`)
};

const id_mk_nav_developers_desc = /** @type {(inputs: Mk_Nav_Developers_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lanjutkan dengan agent, CLI, dan MCP.`)
};

/**
* | output |
* | --- |
* | "Work with your agent, CLI, and MCP." |
*
* @param {Mk_Nav_Developers_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_nav_developers_desc = /** @type {((inputs?: Mk_Nav_Developers_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Nav_Developers_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_nav_developers_desc(inputs)
	return en_mk_nav_developers_desc(inputs)
});